document.addEventListener('DOMContentLoaded', function () {

  const fabricRoot = document.querySelector('[data-br-fabric]');
  const modal = document.querySelector('[data-br-fabric-modal]');

  if (!fabricRoot || !modal) return;

  const modalImage = modal.querySelector('[data-fabric-modal-image]');
  const modalName = modal.querySelector('[data-fabric-modal-name]');
  const modalCode = modal.querySelector('[data-fabric-modal-code]');
  const imageWrapper = modal.querySelector('.br-fabric-modal__image-wrapper');

  const buttons = fabricRoot.querySelectorAll('[data-fabric-open]');
  const closeButtons = modal.querySelectorAll('[data-fabric-close]');
  const selectedText = fabricRoot.querySelector('[data-br-fabric-selected]');

  let scale = 1;

  let translateX = 0;
  let translateY = 0;

  let startX = 0;
  let startY = 0;

  let startTranslateX = 0;
  let startTranslateY = 0;

  let isDragging = false;

  let pinchStartDistance = null;
  let pinchStartScale = 1;


  /* =========================================================
     APLICAR TRANSFORMACIÓN
  ========================================================= */

  function updateTransform() {

    modalImage.style.transform =
      `translate(${translateX}px, ${translateY}px) scale(${scale})`;

    if (scale > 1) {
      modalImage.classList.add('is-zoomed');
    } else {
      modalImage.classList.remove('is-zoomed');
    }

  }


  /* =========================================================
     RESET
  ========================================================= */

  function resetZoom() {

    scale = 1;

    translateX = 0;
    translateY = 0;

    isDragging = false;

    pinchStartDistance = null;

    modalImage.style.transform = 'translate(0px, 0px) scale(1)';

    modalImage.classList.remove('is-zoomed');

  }


  /* =========================================================
     LIMITAR DESPLAZAMIENTO
  ========================================================= */

  function limitPosition() {

    if (scale <= 1) {

      translateX = 0;
      translateY = 0;

      return;

    }

    const wrapperWidth = imageWrapper.clientWidth;
    const wrapperHeight = imageWrapper.clientHeight;

    const imageWidth = modalImage.offsetWidth * scale;
    const imageHeight = modalImage.offsetHeight * scale;

    const maxX = Math.max(0, (imageWidth - wrapperWidth) / 2);
    const maxY = Math.max(0, (imageHeight - wrapperHeight) / 2);

    translateX = Math.max(
      -maxX,
      Math.min(maxX, translateX)
    );

    translateY = Math.max(
      -maxY,
      Math.min(maxY, translateY)
    );

  }


  /* =========================================================
     ZOOM
  ========================================================= */

  function setZoom(newScale) {

    scale = Math.max(
      1,
      Math.min(4, newScale)
    );

    if (scale === 1) {

      translateX = 0;
      translateY = 0;

    }

    limitPosition();

    updateTransform();

  }


  /* =========================================================
     ABRIR MODAL
  ========================================================= */

  buttons.forEach(function (button) {

    button.addEventListener('click', function () {

      const image = button.dataset.fabricImage;
      const name = button.dataset.fabricName || '';
      const code = button.dataset.fabricCode || '';

      modalImage.src = image;
      modalImage.alt = name;

      modalName.textContent = name;

      if (modalCode) {
        modalCode.textContent = code;
      }

      if (selectedText) {
        selectedText.textContent = name;
      }

      resetZoom();

      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');

      document.body.style.overflow = 'hidden';

    });

  });


  /* =========================================================
     CERRAR MODAL
  ========================================================= */

  function closeModal() {

    modal.classList.remove('is-open');

    modal.setAttribute('aria-hidden', 'true');

    document.body.style.overflow = '';

    resetZoom();

  }


  closeButtons.forEach(function (button) {

    button.addEventListener('click', function () {
      closeModal();
    });

  });


  document.addEventListener('keydown', function (event) {

    if (
      event.key === 'Escape' &&
      modal.classList.contains('is-open')
    ) {

      closeModal();

    }

  });


  /* =========================================================
     CLICK EN IMAGEN = ZOOM
  ========================================================= */

  modalImage.addEventListener('click', function (event) {

    event.preventDefault();

    if (scale === 1) {

      setZoom(2);

    } else {

      setZoom(1);

    }

  });


  /* =========================================================
     RUEDA DEL MOUSE
  ========================================================= */

  imageWrapper.addEventListener(
    'wheel',
    function (event) {

      event.preventDefault();

      const delta = event.deltaY < 0
        ? 0.25
        : -0.25;

      setZoom(scale + delta);

    },
    {
      passive: false
    }
  );


  /* =========================================================
     MOUSE DOWN
  ========================================================= */

  imageWrapper.addEventListener(
    'mousedown',
    function (event) {

      if (scale <= 1) return;

      if (event.button !== 0) return;

      event.preventDefault();

      isDragging = true;

      startX = event.clientX;
      startY = event.clientY;

      startTranslateX = translateX;
      startTranslateY = translateY;

      imageWrapper.style.cursor = 'grabbing';

    }
  );


  /* =========================================================
     MOUSE MOVE
  ========================================================= */

  window.addEventListener(
    'mousemove',
    function (event) {

      if (!isDragging) return;

      translateX =
        startTranslateX +
        (event.clientX - startX);

      translateY =
        startTranslateY +
        (event.clientY - startY);

      limitPosition();

      updateTransform();

    }
  );


  /* =========================================================
     MOUSE UP
  ========================================================= */

  window.addEventListener(
    'mouseup',
    function () {

      if (!isDragging) return;

      isDragging = false;

      imageWrapper.style.cursor =
        scale > 1
          ? 'zoom-out'
          : 'zoom-in';

    }
  );


  /* =========================================================
     TOUCH — PINCH
  ========================================================= */

  imageWrapper.addEventListener(
    'touchstart',
    function (event) {

      if (event.touches.length === 2) {

        pinchStartDistance = getDistance(
          event.touches[0],
          event.touches[1]
        );

        pinchStartScale = scale;

      }

      else if (
        event.touches.length === 1 &&
        scale > 1
      ) {

        isDragging = true;

        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;

        startTranslateX = translateX;
        startTranslateY = translateY;

      }

    },
    {
      passive: true
    }
  );


  /* =========================================================
     TOUCH MOVE
  ========================================================= */

  imageWrapper.addEventListener(
    'touchmove',
    function (event) {

      /* -------------------------
         PINCH
      ------------------------- */

      if (
        event.touches.length === 2 &&
        pinchStartDistance
      ) {

        event.preventDefault();

        const currentDistance = getDistance(
          event.touches[0],
          event.touches[1]
        );

        const ratio =
          currentDistance /
          pinchStartDistance;

        setZoom(
          pinchStartScale * ratio
        );

        return;

      }


      /* -------------------------
         DRAG
      ------------------------- */

      if (
        event.touches.length === 1 &&
        isDragging &&
        scale > 1
      ) {

        event.preventDefault();

        translateX =
          startTranslateX +
          (
            event.touches[0].clientX -
            startX
          );

        translateY =
          startTranslateY +
          (
            event.touches[0].clientY -
            startY
          );

        limitPosition();

        updateTransform();

      }

    },
    {
      passive: false
    }
  );


  /* =========================================================
     TOUCH END
  ========================================================= */

  imageWrapper.addEventListener(
    'touchend',
    function (event) {

      if (event.touches.length < 2) {

        pinchStartDistance = null;

      }

      if (event.touches.length === 0) {

        isDragging = false;

      }

    }
  );


  /* =========================================================
     DISTANCIA ENTRE DOS DEDOS
  ========================================================= */

  function getDistance(touch1, touch2) {

    const x =
      touch1.clientX -
      touch2.clientX;

    const y =
      touch1.clientY -
      touch2.clientY;

    return Math.sqrt(
      (x * x) +
      (y * y)
    );

  }


  /* =========================================================
     RESIZE
  ========================================================= */

  window.addEventListener(
    'resize',
    function () {

      if (!modal.classList.contains('is-open')) return;

      limitPosition();

      updateTransform();

    }
  );

});